



































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Dialog, Button } from 'element-ui';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

    @Component({
      components: {
        Dialog,
        Button,
      },
    })
export default class extends Vue {
        @Getter public dialogDescribe: any;

        @Mutation public closeDialog;

        @Mutation public openDialog;

        private close() {
          this.closeDialog();
        }

        private created() {
        }

        private buttonClick(index: number) {
          this.$emit('dialogHandle', index);
        }
}
